export function count<T>(
  iterable: Iterable<T>,
  value: T | ((item: T) => boolean)
): number {
  let count = 0
  const predicate =
    typeof value === 'function'
      ? (value as (item: T) => boolean)
      : (item: T) => item === value

  for (const item of iterable) if (predicate(item)) count++

  return count
}

export function createCustomSorter<T>(order: T[]): (a: T, b: T) => number {
  const orderMap = new Map<T, number>()
  order.forEach((value, index) => {
    orderMap.set(value, index)
  })

  return (a: T, b: T) => {
    const indexA = orderMap.get(a) ?? Number.MAX_SAFE_INTEGER
    const indexB = orderMap.get(b) ?? Number.MAX_SAFE_INTEGER
    return indexA - indexB
  }
}
